import { MSC_TERMS } from '../Booking/termsData';
import { MSC_CAUTION } from '../../utils/cautionData';
import React from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import CommonNavComponent from '../../components/Common-components/NavigatorBar/CommonNavComponent';
import NavScheduleContent from '../../components/Common-components/NavigatorBar/NavigatorContents/navScheduleContent';
import NavBenefits from '../../components/Common-components/NavigatorBar/NavigatorContents/navBenefits';
import NavCautionContent from '../../components/Common-components/NavigatorBar/NavigatorContents/navCautionContent';
import NavTermsNRefundsContent from '../../components/Common-components/NavigatorBar/NavigatorContents/navTermsNRefundsContent';
import NavPassengerContent from '../../components/Common-components/NavigatorBar/NavigatorContents/navPassengerContent';
import { apiGet } from '../../utils/api';
import { openKakaoChat } from '../../utils/kakaoChat';
import { extractOnboardCreditSummaryFromSource, normalizeOnboardCreditSummary } from '../../utils/onboardCredit';
import ReservationPaymentModal from '../../components/Mypage/ReservationPaymentModal';
import { withMscBellissimaCancelNotice } from '../../utils/mscBellissimaCancelNotice';
import '../../css/Mypage/mypageDetail.css';

const NAV_SECTIONS = [
  { id: 'passenger', name: '승객별 요금정보', Component: NavPassengerContent },
  { id: 'schedule', name: '여행일정', Component: NavScheduleContent },
  { id: 'benefit', name: '기본혜택', Component: NavBenefits },
  { id: 'caution', name: '주의사항', Component: NavCautionContent },
  { id: 'term', name: '약관/환불', Component: NavTermsNRefundsContent },
];

const STATUS_CLASS = {
  '-1': 'cancel',
  '0': 'reserved',
  '1': 'paid',
  '2': 'issuance',
  '3': 'onBoard',
  '5': 'external',
};

const STATUS_LABEL = {
  '-1': '취소 내역',
  '0': '예약 완료',
  '1': '부분 결제 완료',
  '2': '결제 완료 / 티켓 발행',
  '3': '승선 완료',
  '5': '연동 예약',
};

const CANCEL_CONTACT_MESSAGE = '예약 취소를 원하시는 경우\n(주)와우크루즈 고객센터(1660-0696)로\n문의해 주시기 바랍니다.';

const MSC_LINE_ID = 16;
const NORWEGIAN_LINE_ID = 17;
const ROYAL_CARIBBEAN_LINE_ID = 22;
const DISNEY_LINE_ID = 73;

const DEFAULT_BENEFITS = [
  {
    title: "",
    items: [
      "매일 밤 펼쳐지는 크루즈 공연",
      "특별 공연 및 선내 프로그램",
      "전일정 선내 뷔페식 & 정찬식 식사",
      "크루즈 숙박 선실료",
      "부대시설 이용료 (일부 유료시설 제외: 면세점, 스파 등)",
      "인솔자가사 경비",
      "DB손해보험 최대 1억원 (A형)",
      "특별 공연 및 선내 프로그램"
    ]
  },
  {
    title: "미니 스위트 객실 ONLY 포함",
    items: [
      "크루즈 선내 팁",
      "일본 출국세",
      "5/25일 부산 도착 후 최윤석 하선"
    ]
  },
  {
    title: "스위트, 그랜드 스위트 객실 ONLY 포함",
    items: [
      "크루즈 선내 팁",
      "일본 출국세",
      "여행 중 음주/주류 패키지 (마이 드링크 +)",
      "웰컴과일 (객실 또는 까나페 & 샴페인 1병)",
      "5/30일 부산 도착 후 최윤석 하선"
    ]
  }
];

const MSC_BENEFITS = [
  {
    title: "MSC 크루즈 기본혜택",
    items: [
      "객실 정비 서비스 (룸 클리닝)",
      "아침/점심/저녁 식사 (정찬, 뷔페, 조식 룸 서비스-벨라 예약 시 배달비 별도)",
      "뷔페 내 물, 커피, 차, 주스 등의 기본음료",
      "선내 공연 및 다양한 액티비티 프로그램",
      "수영장, 피트니스 센터를 포함한 다양한 편의시설",
      "어린이/청소년 프로그램 등"
    ],
    notes: [
      "※ 선실 타입별 포함 사항이 상이하오니, 자세한 내용은 문의 바랍니다."
    ]
  }
];

const ROYAL_CARIBBEAN_BENEFITS = [
  {
    title: "로얄캐리비안 크루즈 기본혜택",
    items: [
      "객실 정비 서비스 (룸 클리닝)",
      "아침/점심/저녁 식사 (정찬, 뷔페, 조식 룸 서비스 등)",
      "물, 커피, 차, 주스 등의 기본음료",
      "선내 공연 및 다양한 액티비티 프로그램",
      "수영장, 피트니스 센터를 포함한 다양한 편의시설",
      "어린이/청소년 프로그램 등"
    ],
    notes: [
      "※ 선실 타입별 포함 사항이 상이하오니, 자세한 내용은 문의 바랍니다."
    ]
  }
];

const NORWEGIAN_BENEFITS = [
  {
    title: "노르웨이지안 크루즈 기본혜택",
    items: [
      "객실 정비 서비스 (룸 클리닝)",
      "아침/점심/저녁 식사 (정찬, 뷔페, 조식 룸 서비스 등)",
      "물, 커피, 차, 주스 등의 기본음료",
      "선내 공연 및 다양한 액티비티 프로그램",
      "수영장, 피트니스 센터를 포함한 다양한 편의시설",
      "어린이/청소년 프로그램 등"
    ],
    notes: [
      "※ 선실 타입별 포함 사항이 상이하오니, 자세한 내용은 문의 바랍니다."
    ]
  }
];

const DISNEY_BENEFITS = [
  {
    title: "디즈니 크루즈 기본혜택",
    items: [
      "객실 정비 서비스 (룸 클리닝)",
      "아침/점심/저녁 식사 (정찬, 뷔페, 조식 룸 서비스 등)",
      "물, 커피, 차, 주스 등 기본음료와 탄산음료",
      "선내 공연 및 다양한 액티비티 프로그램",
      "수영장, 피트니스 센터를 포함한 다양한 편의시설",
      "어린이/청소년 프로그램 등"
    ],
    notes: [
      "※ 선실 타입별 포함 사항이 상이하오니, 자세한 내용은 문의 바랍니다."
    ]
  }
];

const DEFAULT_CAUTION = [
  "상기 일정은 날씨(천재지변) 및 선사 사정에 따라서 사전 통보없이 변경될 수 있습니다.",
  "크루즈 출발시간 최소 3시간 전 항구에 도착하여 승선수속을 진행해야 하며, 귀국 항공편은 크루즈 도착 기준 약 5~6시간 이후로 예약",
  "현재 제공되는 일부 이미지 및 고객 안내사항은 선내 또는 기항지에서 요구되거나 제한되는 공중보건 규칙과 정부 요건을 정확하게 반영하지 못할 수 있습니다."
];

const ROYAL_CARIBBEAN_CAUTION = [
  { text: "상기 일정은 날씨(천재지변) 및 선사 사정에 따라서 사전 통보없이 변경될 수 있습니다." },
  { text: "크루즈 출발 최소 3시간 전 항구에 도착하여 승선수속을 진행해야 하며, 귀국 항공편은 크루즈 도착 기준 약 5~6시간 이후로 예약하시기 바랍니다." },
  { text: "현재 제공되는 일부 이미지 및 고객 안내사항은 선내 또는 기항지에서 요구되거나 제한되는 공중보건 규칙과 정부 요건을 정확하게 반영하지 못할 수 있습니다." },
  {
    text: "이름변경",
    subItems: [
      "예약자 중 최소 1명의 이름은 그대로 유지되어야 합니다. 선사 재량에 따라 이름 변경 수수료 1인당 $50 발생할 수 있습니다."
    ]
  },
  {
    text: "일정 변경",
    subItems: [
      { type: "note", text: "[일정 변경 수수료]" },
      {
        text: "취소료 부과 이전 시점",
        subItems: [
          "무료 취소 가능 예약: 무료",
          "예약금 환불 불가(NRD) 예약: 매회 서비스 차지(1인당 USD 100)"
        ]
      },
      {
        text: "취소료 부과 시점",
        subItems: [
          "취소료 부과 시점부터는 예약 조건에 관계없이 해당 시점의 취소료가 적용됩니다.",
          "선사 사정에 따라 일정 변경이 불가할 수 있습니다."
        ]
      }
    ]
  },
  {
    text: "선상팁",
    subItems: [
      "선상팁을 사전 지불하지 않는 경우 선사 규정에 따라 선상팁은 추후 변경될 수 있습니다.",
      "로얄캐리비안 크루즈를 이용하는 모든 고객은 선상팁(Gratuities)을 지불해야하며, 선실 등급, 예약 시점에 따라 선상팁 비용이 상이합니다. 예약 완료 단계 내 '추가서비스'에서 선상팁 금액 확인 및 선지불 선택 가능합니다. 선상팁 후지불 선택 시, 추후 선사의 정책에 따라 금액이 변경 될 수 있습니다.",
      {
        text: "스위트 선실 이용 고객",
        subItems: [
          "1인 1박당 USD $21.00"
        ]
      },
      {
        text: "그 외 모든 선실 이용 고객",
        subItems: [
          "1인 1박당 USD $18.50"
        ]
      }
    ]
  },
  {
    text: "미성년자 탑승 규정",
    subItems: [
      "원칙: 미성년자(만 18세 이하) 승객은 최소 1명의 성인(Adult)과 동일 객실에 투숙해야 합니다.",
      "예외: 부모/법정대리인이 동반하지 않는 경우, 예약 시 예외 요청과 함께 부모/법정대리인의 동의서 및 지정 보호자 정보 등을 제출해야 합니다.",
      { type: "note", text: "*미국 출발 또는 미국을 여행(기항 포함)하는 크루즈의 경우 만 21세 이상 이어야 합니다." }
    ]
  },
  {
    text: "임산부 승선 규정",
    subItems: [
      "탑승 가능: 임신 주수가 23주 이하인 경우에 한해, 의사 소견서 및 임신 주수 증빙서류를 승선(출항) 30일 전까지 제출하면 승선 가능합니다.",
      "탑승 불가: 크루즈 기간 중 어느 시점이든 임신 24 초과가 되는 경우, 안전상 승선이 거절됩니다."
    ]
  },
  {
    text: "휠체어 반입 규정",
    subItems: [
      "사전 신고 필수: 휠체어/스쿠터는 승선 전 반드시 선사 측에 신고해야 하며, 사전 신고가 없을 경우 승선/반입이 거절될 수 있습니다.",
      "배터리 규정: 신고시, 배터리 유형을 Gel / Dry / Wet로 선택하도록 되어 있고, “배터리 타입”을 요구합니다.",
      "복도 보관 금지: 안전을 위해 복도/통로 보관은 불가하며, 객실 내 보관이 원칙입니다.",
      "터미널 승·하선 도움: 휠체어/거동 불편 고객은 부두에서 승·하선 보조 요청 가능하며, 이를 위해 출항 최소 30일 전 신청을 권장합니다."
    ]
  }
];

const NORWEGIAN_CAUTION = [
  { text: "상기 일정은 날씨(천재지변) 및 선사 사정에 따라서 사전 통보없이 변경될 수 있습니다." },
  { text: "크루즈 출발 최소 3시간 전 항구에 도착하여 승선수속을 진행해야 하며, 귀국 항공편은 크루즈 도착 기준 약 5~6시간 이후로 예약하시기 바랍니다." },
  { text: "현재 제공되는 일부 이미지 및 고객 안내사항은 선내 또는 기항지에서 요구되거나 제한되는 공중보건 규칙과 정부 요건을 정확하게 반영하지 못할 수 있습니다." },
  {
    text: "이름변경",
    subItems: [
      "출항일 기준 90일 전까지는 예약자 전원의 성명 변경이 가능합니다.",
      "출항일 기준 89일 전부터 15일 전까지는 1회에 한하여 성명 변경이 허용되며, 이 경우 예약자 중 최소 1인의 성명은 유지되어야 합니다.",
      "출항일 기준 14일 이내의 모든 성명 변경은 취소 규정에 따른 위약금이 적용됩니다."
    ]
  },
  {
    text: "선상팁",
    subItems: [
      "선상팁을 사전 지불하지 않는 경우 선사 규정에 따라 선상팁은 추후 변경될 수 있습니다.",
      "노르웨이지안 크루즈를 이용하는 모든 고객은 선상팁(Service Charge)을 지불해야하며, 선실 등급, 예약 시점에 따라 선상팁 비용이 상이합니다. 예약 완료 단계 내 '추가서비스'에서 선상팁 금액 확인 및 선지불 선택 가능합니다. 선상팁 후지불 선택 시, 추후 선사의 정책에 따라 금액이 변경 될 수 있습니다.",
      "선상팁은 만 3세 이상 모든 승객에게 동일하게 적용됩니다.",
      { type: "note", text: "2023년 1월 1일 이후 예약 건" },
      {
        text: "더 헤이븐(The Haven) 및 스위트 선실",
        subItems: [
          "1인 1박당 USD $25.00"
        ]
      },
      {
        text: "클럽 발코니 스위트 이하 선실",
        subItems: [
          "1인 1박당 USD $20.00"
        ]
      },
      { type: "note", text: "※ 하와이로 운항하는 크루즈의 경우, 사전 결제된 서비스 차지 금액에 4.712%의 하와이 일반소비세(GET)가 추가로 부과됩니다." }
    ]
  },
  {
    text: "미성년자 탑승 규정",
    subItems: [
      "미성년자(Minor) 기준: 승선일 기준 만 18세 미만",
      "청년(Young Adult) 구분: 만 18-20세",
      "원칙: 만 21세 미만(= 미성년자 & 18-20세) 승객은 최소 1명의 성인(Adult)과 동일 객실에 투숙해야 합니다.",
      "예외: 부모/법정대리인이 동반하지 않는 경우, 예약 시 예외 요청과 함께 부모/법정대리인의 동의서 및 지정 보호자 정보 등을 제출해야 합니다.",
      "만 18세 이상 두 사람이 부부(혼인 증빙)이면, 둘 다 만 21세 미만이어도 같은 객실 여행 가능합니다.",
      { type: "note", text: "*미국 출발 또는 미국을 여행(기항 포함)하는 크루즈의 경우 만 21세 이상 이어야 합니다." }
    ]
  },
  {
    text: "임산부 승선 규정",
    subItems: [
      "탑승 가능: 임신 주수가 24주차 이하인 경우에 한해, 의사 소견서 및 임신 주수 증빙서류를 승선(출항) 30일 전까지 제출하면 승선 가능합니다.",
      "탑승 불가: 크루즈 기간 중 어느 시점이든 임신 24 초과가 되는 경우, 안전상 승선이 거절됩니다."
    ]
  },
  {
    text: "휠체어 반입 규정",
    subItems: [
      "사전 신고 필수: 휠체어/스쿠터는 최소 승선 30일 전 반드시 선사 측에 신고해야 하며, 사전 신고가 없을 경우 승선/반입이 거절될 수 있습니다.",
      "복도 보관 금지: 안전을 위해 복도/통로 보관은 불가하며, 객실 내 보관이 원칙입니다."
    ]
  }
];

const DISNEY_CAUTION = [
  { text: "상기 일정은 날씨(천재지변) 및 선사 사정에 따라서 사전 통보없이 변경될 수 있습니다." },
  { text: "크루즈 출발 최소 3시간 전 항구에 도착하여 승선수속을 진행해야 하며, 귀국 항공편은 크루즈 도착 기준 약 5~6시간 이후로 예약하시기 바랍니다." },
  { text: "현재 제공되는 일부 이미지 및 고객 안내사항은 선내 또는 기항지에서 요구되거나 제한되는 공중보건 규칙과 정부 요건을 정확하게 반영하지 못할 수 있습니다." },
  {
    text: "이름변경",
    subItems: [
      "예약자 중 최소 1명의 이름은 그대로 유지되어야 합니다. 선사 재량에 따라 이름 변경 수수료 1인당 $50 발생할 수 있습니다."
    ]
  },
  {
    text: "선상팁",
    subItems: [
      "선상팁을 사전 지불하지 않는 경우 선사 규정에 따라 선상팁은 추후 변경될 수 있습니다.",
      "디즈니크루즈를 이용하는 모든 고객은 선상팁을 지불해야하며, 등급에 따른 선상팁 비용은 아래와 같습니다.",
      {
        text: "내측 / 오션뷰 / 베란다",
        subItems: [
          "1인 1박당 USD $16"
        ]
      },
      {
        text: "컨시어지 / 스위트",
        subItems: [
          "1인 1박당 USD $27.25"
        ]
      }
    ]
  },
  {
    text: "미성년자 탑승 규정",
    subItems: [
      "원칙: 미성년자(만 18세이하) 승객은 최소 1명의 성인(Adult)과 동일 객실에 투숙해야 합니다.",
      "예외: 부모/법정대리인이 동반하지 않는 경우, 예약 시 예외 요청과 함께 부모/법정대리인의 동의서 및 지정 보호자 정보 등을 승선 전 제출해야 합니다.",
      { type: "note", text: "*미국 출발 또는 미국을 여행(기항 포함)하는 크루즈의 경우 단독 여행은 만 21세 이상이어야 합니다." }
    ]
  },
  {
    text: "임산부 승선 규정",
    subItems: [
      "탑승 가능: 임신 주수가 24주차 이하인 경우에 한해, 의사 소견서 및 임신 주수 증빙서류를 승선(출항) 30일 전까지 제출하면 승선 가능합니다.",
      "탑승 불가: 크루즈 기간 중 어느 시점이든 임신 24 초과가 되는 경우, 안전상 승선이 거절됩니다."
    ]
  },
  {
    text: "휠체어 반입 규정",
    subItems: [
      "사전 신고 필수: 휠체어/스쿠터는 승선 최소 30일 전 반드시 선사 측에 신고해야 하며, 사전 신고가 없을 경우 승선/반입이 거절될 수 있습니다.",
      "복도 보관 금지: 안전을 위해 복도/통로 보관은 불가하며, 객실 내 보관이 원칙입니다."
    ]
  }
];

const DEFAULT_TERMS = [
  {
    title: "특별 약관",
    description: "본 상품의 취소는 국외여행 표준약관 제16조 외에 약관 제6조에 의해 '국외여행 특별약관'이 적용됩니다. 특별약관은 표준약관보다 높은 취소료가 부과될 수 있으니 세부기준을 반드시 확인하셔야 합니다.",
    items: [
      "취소료는 크루즈 선사 규정을 따르며 예외사항이 없습니다.",
      "예약금 이상의 취소료가 발생하는 시점부터는 차액을 추가로 납부하셔야 합니다."
    ],
    extra: {
      type: "link",
      text: "약관 상세 보기 >",
      url: "#"
    }
  },
  {
    title: "취소료 규정",
    description: "",
    items: [
      "출항~ 91일 전 취소 시(예약일~2월 28일): 위약금 없음",
      "출항 90일 ~ 61일 전 취소 시(3월 1일~3월 30일): 여행경비의 30%",
      "출항 60일 ~ 31일 전 취소 시(3월 31일~4월 29일): 여행경비의 50%",
      "출항 30일 ~ 출발 당일 취소 시(4월 30일 이후): 여행경비의 100%"
    ],
    extra: {
      type: "notes",
      notes: [
        "*취소 접수는 업무시간 내에 유선 접수만 가능합니다.",
        "*접수시간: 월~금 9:30~15:00, 토/일요일 공휴일 제외"
      ]
    }
  }
];


const ROYAL_CARIBBEAN_TERMS = [
  {
    title: "특별 약관",
    description: "※ 로얄캐리비안 크루즈는 일반 해외여행시 적용되는 국외여행표준약관이 아닌 특별 크루즈 약관에 따라 취소 규정이 적용됩니다. 이 규정은 로얄캐리비안 크루즈 이용시 전세계에 공통 적용되는 규정입니다. 이에 따른 취소료 규정을 꼭 확인해주시기 바랍니다.",
    items: [
      "취소료는 크루즈 선사 규정을 따르며 예외사항이 없습니다.",
      "예약금 이상의 취소료가 발생하는 시점부터는 차액을 추가로 납부하셔야 합니다."
    ]
  },
  {
    title: "취소료 규정",
    description: "",
    items: [
      { type: "note", text: "로얄캐리비안 크루즈의 취소 규정은 크루즈 출항일과 일정 길이에 따라 다르게 적용됩니다." },
      { type: "note", text: "예약금은 상품 및 프로모션 조건에 따라 환불 불가(NRD)로 적용될 수 있습니다." },
      { type: "note", text: "예약 변경 또는 취소를 원하실 경우, 아래 규정을 반드시 확인해주시기 바랍니다." },
      { type: "label", text: "[1- 5박 일정]" },
      "75일 전: 무료 (단, 예약금 환불불가 조건은 1인당 USD 150)",
      "74 - 60일 : 예약금",
      "59 - 30일 : 총 요금의 50%",
      "29 - 15일 : 총 요금의 75%",
      "14 - 출발 당일 : 총 요금의 100%",
      { type: "label", text: "[6박 - 9박 일정]" },
      "90일 전 : 무료 (단, 예약금 환불불가 조건은 1인당 USD 350)",
      "89 - 75일 : 예약금",
      "74 - 45일 : 총 요금의 50%",
      "44 - 15일 : 총 요금의 75%",
      "14 - 출발 당일 : 총 요금의 100%",
      { type: "label", text: "[10박 - 14박 일정]" },
      "90일 전 : 무료 (단, 예약금 환불불가 조건은 1인당 USD 500)",
      "89 - 75일 : 예약금",
      "74 - 61일 : 총 요금의 50%",
      "60 - 31일 : 총 요금의 75%",
      "30 - 출발 당일 : 총 요금의 100%",
      { type: "label", text: "[15박 이상 일정]" },
      "121일 전 : 무료 (단, 예약금 환불불가 조건은 1인당 USD 500)",
      "120 - 61일 : 총 요금의 25%",
      "60 - 41일 : 총 요금의 50%",
      "40 - 25일 : 총 요금의 75%",
      "24 - 출발 당일 : 총 요금의 100%",
      { type: "label", text: "[예약금 안내]" },
      { type: "note", text: "*1~5박: 1인당 USD 150" },
      { type: "note", text: "*6~9박: 1인당 USD 350" },
      { type: "note", text: "*10박 이상: 1인당 USD 500" },
      { type: "note", text: "*스위트: 크루즈 요금의 10% 또는 위 금액 중 큰 금액" },
      { type: "note", text: "*아이콘호 STAR 등급: 1인당 USD 600" },
      { type: "note", text: "※ 예약금 환불 불가(NRD) 조건으로 예약하신 경우, 결제하신 예약금은 환불되지 않습니다." },
      { type: "note", text: "※ 선실 요금의 25%, 50% 시점에 부과되는 취소료가 예약금보다 낮을 경우, 예약금 금액이 취소료로 부과됩니다." },
      { type: "note", text: "※ 취소 요청 접수 시간은 평일 09:30 ~ 15:00(토, 공휴일 휴무)입니다. 접수시간 이후 취소 요청은 다음 영업일 기준으로 취소 처리가 진행 되며, 이에 따른 취소료가 적용됩니다." }
    ]
  }
];

const NORWEGIAN_TERMS = [
  {
    title: "특별 약관",
    description: "※ 노르웨이지안 크루즈는 일반 해외여행시 적용되는 국외여행표준약관이 아닌 특별 크루즈 약관에 따라 취소 규정이 적용됩니다. 이 규정은 노르웨이지안 크루즈 이용시 전세계에 공통 적용되는 규정입니다. 이에 따른 취소료 규정을 꼭 확인해주시기 바랍니다.",
    items: [
      "취소료는 크루즈 선사 규정을 따르며 예외사항이 없습니다.",
      "예약금 이상의 취소료가 발생하는 시점부터는 차액을 추가로 납부하셔야 합니다."
    ]
  },
  {
    title: "취소료 규정",
    description: "",
    items: [
      { type: "label", text: "[취소료 규정]" },
      "90일 전 : 무료",
      "89일 - 75 일 전 : 예약금 (총 요금의 20%)",
      "74일 - 50일 전 : 총 요금의 25%",
      "49일 - 29일 전 : 총 요금의 50%",
      "28일 - 15일 전 : 총 요금의 75%",
      "14일 - 출발일 : 총 요금의 100%",
      { type: "note", text: "※ BOGOFREE 프로모션(1번째 승객 요금 결제 시 2번째 승객은 무료, 단 세금은 별도 부담)의 경우, 지불된 예약금은 환불이 불가능합니다. 할인된 예약금(Reduced Deposit) 프로모션은 스위트(Suite) 및 헤이븐(Haven) 카테고리에는 적용되지 않습니다. 따라서 스위트 또는 헤이븐으로 업그레이드할 경우, 예약금 전액을 즉시 납부해야 합니다." },
      { type: "note", text: "※ 예약 확정 후 모든 변경 요청은 취소료 부과 이전 시점에만 가능하며, 취소료 부과 시점 이후에는 모든 예약 변경이 불가능합니다." },
      { type: "note", text: "※ 선실 요금의 25%, 50% 시점에 부과되는 취소료가 예약금보다 낮을 경우, 예약금이 취소료로 부과됩니다." },
      { type: "note", text: "※ 취소 요청 접수 시간은 평일 09:30 ~ 15:00(토, 공휴일 휴무)입니다. 접수시간 이후 취소 요청은 다음 영업일 기준으로 취소 처리가 진행 되며, 이에 따른 취소료가 적용됩니다." }
    ]
  }
];

const DISNEY_TERMS = [
  {
    title: "특별 약관",
    description: "※ 디즈니 크루즈는 일반 해외여행시 적용되는 국외여행표준약관이 아닌 특별 크루즈 약관에 따라 취소 규정이 적용됩니다. 이 규정은 디즈니 크루즈 이용시 전세계에 공통 적용되는 규정입니다. 이에 따른 취소료 규정을 꼭 확인해주시기 바랍니다.",
    items: [
      "취소료는 크루즈 선사 규정을 따르며 예외사항이 없습니다.",
      "예약금 이상의 취소료가 발생하는 시점부터는 차액을 추가로 납부하셔야 합니다."
    ]
  },
  {
    title: "취소료 규정",
    description: "",
    items: [
      { type: "label", text: "[1- 5박 일정]" },
      { type: "label", text: "*내측 / 오션뷰 / 베란다" },
      "예약일 - 90일 전 : 무료",
      "89일 - 45일 전 : 예약금 (총 요금의 10%)",
      "44일 - 30일 전 : 총 요금의 50%",
      "29 - 15일 전 : 총 요금의 75%",
      "14 - 출발일 : 총 요금의 100%",
      { type: "label", text: "*컨시어지 / 스위트" },
      "예약일 - 45일 전 : 예약금 (총 요금의 10%)",
      "44일 - 30일 전 : 총 요금의 50%",
      "29 - 15일 전 : 총 요금의 75%",
      "14 - 출발일 : 총 요금의 100%",
      { type: "label", text: "[6박 이상 일정]" },
      { type: "label", text: "*내측 / 오션뷰 / 베란다" },
      "예약일 - 120일 전 : 무료",
      "119일 - 56일 전 : 예약금 (총 요금의 10%)",
      "55일 - 30일 전 : 총 요금의 50%",
      "29 - 15일 전 : 총 요금의 75%",
      "14 - 출발일 : 총 요금의 100%",
      { type: "label", text: "*컨시어지 / 스위트" },
      "예약일 - 56일 전 : 예약금 (총 요금의 10%)",
      "55일 - 30일 전 : 총 요금의 50%",
      "29 - 15일 전 : 총 요금의 75%",
      "14 - 출발일 : 총 요금의 100%",
      { type: "note", text: "※ 인사이드 개런티, 오션뷰 개런티, 베란다 개런티 등급으로 예약 시, 크루즈 요금은 100% 환불 불가합니다." },
      { type: "note", text: "예약 확정을 위한 예약금은 크루즈 요금의 10%입니다." },
      { type: "note", text: "※ 예약 후 모든 변경이 불가능하며, 예약 규정에 따라 취소료가 발생합니다." },
      { type: "note", text: "※ 취소 요청 접수 시간은 평일 09:30 ~ 15:00(토, 공휴일 휴무)입니다. 접수시간 이후 취소 요청은 다음 영업일 기준으로 취소 처리가 진행 되며, 이에 따른 취소료가 적용됩니다." }
    ]
  }
];

const STATUS_PATH_MAP = {
  '-1': 'cancellation-history',
  '0': 'reservation-complete',
  '1': 'partial-payment',
  '2': 'payment-complete',
  '3': 'boarding-complete',
  '5': 'external-reservation',
};

const mapStatusClass = status => STATUS_CLASS[status] ?? status;
const mapStatusLabel = (status, fallback) => STATUS_LABEL[status] ?? fallback ?? status;
const parseCruiseDate = (rawValue) => {
  if (!rawValue) return null;
  if (rawValue instanceof Date && !Number.isNaN(rawValue.getTime())) {
    return new Date(rawValue.getTime());
  }

  let parsed = new Date(rawValue);
  if (Number.isNaN(parsed.getTime()) && typeof rawValue === 'string') {
    const normalized = rawValue
      .replace(/년|월/g, '-')
      .replace(/일/g, '')
      .replace(/\./g, '-')
      .replace(/\s+/g, '');
    parsed = new Date(normalized);
  }

  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const isCruiseEnded = (endDateRaw, sailDateRaw) => {
  const baseDate = parseCruiseDate(endDateRaw) || parseCruiseDate(sailDateRaw);
  if (!baseDate) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  baseDate.setHours(0, 0, 0, 0);
  return baseDate < today;
};

const getStatusPath = (status, ticketIssueReady, options = {}) => {
  if (status === '2') {
    if (options.forceBoardingComplete) {
      return 'boarding-complete';
    }
    return ticketIssueReady ? 'ticket-issue' : 'payment-complete';
  }
  return STATUS_PATH_MAP[status];
};

const transformPassengers = paxList => {
  if (!Array.isArray(paxList)) return [];

  return paxList.map(pax => {
    const cabinPrice = Number(pax.cabin_price ?? 0);
    const taxPrice = Number(pax.tax_price ?? 0);
    const tipPrice = Number(pax.tip_price ?? 0);
    const totalFinal = cabinPrice + taxPrice + tipPrice;
    const phoneVal = (pax.phone ?? '').trim();
    const lastName = String(pax.last_name ?? '').trim();
    const firstName = String(pax.first_name ?? '').trim();

    return {
      name: [lastName, firstName].filter(Boolean).join(' '),
      lastName,
      firstName,
      birth: `${pax.birth_year}-${pax.birth_month}-${pax.birth_day}`,
      gender: pax.gender,
      country: pax.nation,
      phone: phoneVal !== '' ? phoneVal : '-',
      fare: {
        original: cabinPrice,
        discounted: cabinPrice,
      },
      tax: taxPrice,
      gratuity: tipPrice,
      total: { original: totalFinal, final: totalFinal },
    };
  });
};

function MypageDetail() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const urlIdx = searchParams.get('idx');
  const statusParam = searchParams.get('status');
  const navigate = useNavigate();

  const reservationCodeFromState = location.state?.reservationCode;
  const statusCode = String(statusParam ?? '');
  const isBoardingCompletePath = location.pathname.startsWith('/mypage/boarding-complete');
  const externalReservationRef = React.useRef(statusCode === '5');

  const [reservationDetail, setReservationDetail] = React.useState(null);
  const [reservationLoading, setReservationLoading] = React.useState(true);
  const [reservationError, setReservationError] = React.useState(null);
  const [detailRefreshKey, setDetailRefreshKey] = React.useState(0);
  const [showPaymentModal, setShowPaymentModal] = React.useState(false);

  const [scheduleData, setScheduleData] = React.useState({ simple: [], detail: [], map: null });
  const [, setScheduleLoading] = React.useState(false);

  const reservationEnded = React.useMemo(
    () => isCruiseEnded(reservationDetail?.end_date, reservationDetail?.sail_date),
    [reservationDetail?.end_date, reservationDetail?.sail_date]
  );
  const displayStatusCode = React.useMemo(() => {
    const currentStatus = reservationDetail?.reservation_status != null
      ? String(reservationDetail.reservation_status) : statusCode;
    if (isBoardingCompletePath && (currentStatus === '2' || currentStatus === '3') && reservationEnded) {
      return '3';
    }
    return currentStatus;
  }, [isBoardingCompletePath, statusCode, reservationDetail?.reservation_status, reservationEnded]);
  const statusClass = mapStatusClass(displayStatusCode);

  React.useEffect(() => {
    const apiStatus = Number(reservationDetail?.reservation_status ?? NaN);
    if (statusCode === '5' || apiStatus === 5) {
      externalReservationRef.current = true;
    }
  }, [reservationDetail?.reservation_status, statusCode]);

  React.useEffect(() => {
    if (!urlIdx) {
      setReservationLoading(false);
      return;
    }

    let mounted = true;
    setReservationLoading(true);
    setReservationDetail(null);
    setScheduleData({ simple: [], detail: [], map: null });
    setReservationError(null);
    const handleUnauthorizedAccess = (message) => {
      alert(message || '예약 상세 정보에 접근할 수 없습니다.');
      navigate('/mypage', { replace: true });
    };
    const isUnauthorizedResponse = (payload, status) => {
      const code = payload?.code ?? status;
      const normalizedCode = code != null ? String(code) : '';
      return normalizedCode === '401' || normalizedCode === '403';
    };

    const isExternalReservation = location.state?.is_external_reservation === true;
    const requestParams = { idx: urlIdx };
    if (isExternalReservation) {
      requestParams.is_external_reservation = true;
    }
    apiGet('/reservation/get_reservation_detail.php', requestParams)
      .then(response => {
        if (!mounted) return;
        if (response?.success) {
          const apiStatus = Number(response?.reservation_status ?? response?.status ?? null);
          if (apiStatus === -2) {
            alert('이미 만료된 예약입니다.');
            const backPath = location.pathname.replace(/\/detail.*$/, '') || '/mypage';
            navigate(backPath, {
              replace: true,
              state: { ...(location.state || {}), refreshList: true },
            });
            return;
          }
          setReservationDetail(response);
        } else if (isUnauthorizedResponse(response)) {
          handleUnauthorizedAccess(response?.message || response?.reason);
        } else {
          setReservationError('예약 상세 정보를 불러올 수 없습니다.');
        }
      })
      .catch((error) => {
        if (!mounted) return;
        const payload = error?.response?.data;
        const status = error?.response?.status;
        if (isUnauthorizedResponse(payload, status)) {
          handleUnauthorizedAccess(payload?.message || payload?.reason);
          return;
        }
        setReservationError('예약 상세 정보를 불러올 수 없습니다.');
      })
      .finally(() => {
        if (mounted) setReservationLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [detailRefreshKey, urlIdx, navigate, location.pathname, location.state]);

  // 상태가 갱신되어 탭이 달라질 경우, 해당 탭 경로로 리다이렉트
  React.useEffect(() => {
    if (!reservationDetail || !urlIdx) return;
    const apiStatus = String(reservationDetail.reservation_status ?? '');
    const ticketIssueReady = reservationDetail?.ticket_issue_ready === true;
    const shouldStayOnBoardingComplete =
      isBoardingCompletePath && apiStatus === '2' && reservationEnded;
    const targetPath = getStatusPath(apiStatus, ticketIssueReady, {
      forceBoardingComplete: shouldStayOnBoardingComplete,
    });
    if (!targetPath) return;

    const expectedPrefix = `/mypage/${targetPath}`;
    if (!location.pathname.startsWith(expectedPrefix)) {
      const nextState = { ...(location.state || {}), refreshList: true };
      if (externalReservationRef.current) {
        nextState.is_external_reservation = true;
      }
      navigate(`/mypage/${targetPath}/detail?status=${apiStatus}&idx=${urlIdx}`, {
        replace: true,
        state: nextState,
      });
    }
  }, [reservationDetail, urlIdx, navigate, location.state, location.pathname, isBoardingCompletePath, reservationEnded]);

  const statusLabel = React.useMemo(() => {
    if (displayStatusCode === '3') {
      return '승선 완료';
    }
    if (displayStatusCode === '2') {
      return reservationDetail?.ticket_issue_ready ? '티켓 발행' : '결제 완료';
    }
    return mapStatusLabel(displayStatusCode, '상태 미정');
  }, [displayStatusCode, reservationDetail?.ticket_issue_ready]);

  React.useEffect(() => {
    // The detail request refreshes the reservation's sailing link. Fetch the itinerary
    // only after that request finishes, so the first view cannot use the old sailing.
    if (!urlIdx || reservationLoading || !reservationDetail
      || String(reservationDetail.reservation_idx) !== String(urlIdx)) {
      setScheduleData({ simple: [], detail: [], map: null });
      setScheduleLoading(false);
      return;
    }

    let mounted = true;
    setScheduleLoading(true);

    apiGet('/schedule/get_cruise_schedule_detail.php', { reservation_idx: urlIdx })
      .then(res => {
        if (!mounted) return;
        const data = res?.data ?? res;
        if (res?.result !== 'success' || !data?.schedule) {
          throw new Error(res?.message || '예약 일정을 불러올 수 없습니다.');
        }
        setScheduleData({
          simple: [
            { date: data.schedule.saildate, type: 'departure', location: data.schedule.departure_port_name },
            { date: data.schedule.enddate, type: 'arrival', location: data.schedule.arrival_port_name },
          ],
          map: data.schedule.itinerary_image_url, // 항해 지도
          detail: data.itinerary, // 상세 항해 일정
        });
      })
      .catch(() => {
        if (!mounted) return;
        setScheduleData({ simple: [], detail: [], map: null });
      })
      .finally(() => {
        if (mounted) setScheduleLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [urlIdx, reservationLoading, reservationDetail]);

  const passengers = React.useMemo(
    () => transformPassengers(reservationDetail?.pax_list),
    [reservationDetail?.pax_list]
  );
  const parseMoneyValue = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const normalized = typeof value === 'string' ? value.replace(/,/g, '') : value;
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  };
  const formatUsdCurrency = (value) => {
    const amount = parseMoneyValue(value);
    if (amount === null) return '$0.00';
    return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };

  const receivedTotalRaw = parseMoneyValue(reservationDetail?.received_total);
  const spriceRaw = parseMoneyValue(reservationDetail?.sprice);
  const netpriceRaw = parseMoneyValue(reservationDetail?.netprice ?? reservationDetail?.nettprice);
  const spriceTotal = spriceRaw ?? netpriceRaw;
  const paymentSummary = reservationDetail?.payment_summary ?? null;
  const paymentAction = reservationDetail?.payment_action ?? null;
  const paymentReceipts = React.useMemo(
    () => (Array.isArray(reservationDetail?.payment_receipts) ? reservationDetail.payment_receipts : []),
    [reservationDetail?.payment_receipts]
  );
  const hasFullNetPrice = Number(reservationDetail?.line_id ?? 0) === MSC_LINE_ID
    && receivedTotalRaw !== null
    && netpriceRaw !== null
    && spriceRaw !== null
    && receivedTotalRaw >= netpriceRaw;
  const normalizedReceivedTotal = hasFullNetPrice ? spriceRaw : receivedTotalRaw;
  const receivedTotal = normalizedReceivedTotal !== null && spriceTotal !== null
    ? Math.min(normalizedReceivedTotal, spriceTotal)
    : normalizedReceivedTotal;
  const selectedPromotions = React.useMemo(
    () => (Array.isArray(reservationDetail?.selected_promotions) ? reservationDetail.selected_promotions : []),
    [reservationDetail?.selected_promotions]
  );
  const selectedExtras = React.useMemo(
    () => (Array.isArray(reservationDetail?.selected_extras) ? reservationDetail.selected_extras : []),
    [reservationDetail?.selected_extras]
  );
  const onboardCreditSummary = React.useMemo(() => {
    const normalized = normalizeOnboardCreditSummary(reservationDetail?.onboard_credit);
    if (normalized) return normalized;

    const importCruiseItem = reservationDetail?.import_sync?.payload?.results?.[0]?.cruiseitem;
    return extractOnboardCreditSummaryFromSource(importCruiseItem);
  }, [reservationDetail?.import_sync?.payload, reservationDetail?.onboard_credit]);
  const lineId = Number(reservationDetail?.line_id ?? 0);
  const isMscLine = lineId === MSC_LINE_ID;
  const isNorwegianLine = lineId === NORWEGIAN_LINE_ID;
  const isRoyalCaribbeanLine = lineId === ROYAL_CARIBBEAN_LINE_ID;
  const isDisneyLine = lineId === DISNEY_LINE_ID;
  const mscCancelNoticeContext = React.useMemo(() => ({
    lineId,
    shipId: reservationDetail?.ship_code || reservationDetail?.ship_id,
    sailDate: reservationDetail?.cs_saildate || reservationDetail?.sail_date || reservationDetail?.sail_date_kr,
    departurePort: reservationDetail?.departs_port || reservationDetail?.departure_port,
    arrivalPort: reservationDetail?.ends_port || reservationDetail?.arrival_port,
    reservationDate: reservationDetail?.create_date,
  }), [
    lineId,
    reservationDetail?.ship_code,
    reservationDetail?.ship_id,
    reservationDetail?.cs_saildate,
    reservationDetail?.sail_date,
    reservationDetail?.sail_date_kr,
    reservationDetail?.departs_port,
    reservationDetail?.departure_port,
    reservationDetail?.ends_port,
    reservationDetail?.arrival_port,
    reservationDetail?.create_date,
  ]);
  const paymentActionAmount = parseMoneyValue(paymentAction?.default_amount);
  const paymentActionAmountLabel = paymentActionAmount !== null
    ? formatUsdCurrency(paymentActionAmount)
    : '$0.00';
  const canUseReservationDetailPayment = paymentAction?.available === true;
  // A blocked payment action does not confirm that the remaining balance was paid.
  const partialPaymentNotice = canUseReservationDetailPayment
    ? {
      title: '추가 결제가 가능합니다.',
      description: '예약금 결제가 반영되었습니다. 남은 잔금을 결제하시면 다음 단계로 진행됩니다.',
    }
    : {
      title: '일부 금액이 결제되었습니다.',
      description: '현재 추가 결제를 진행할 수 없습니다. 아래 결제 내역과 예약 상태를 확인해 주세요.',
    };
  if (!canUseReservationDetailPayment && paymentAction?.reason === 'PAYMENT_REVIEW_REQUIRED') {
    partialPaymentNotice.title = '추가 결제 결과 확인이 필요합니다.';
    partialPaymentNotice.description = '기존 결제 내역은 유지되며, 이번 추가 결제의 완료 여부는 확인이 필요합니다.';
  } else if (!canUseReservationDetailPayment && paymentAction?.reason === 'PAYMENT_HISTORY_UNAVAILABLE') {
    partialPaymentNotice.title = '결제 상태 확인이 필요합니다.';
    partialPaymentNotice.description = '현재 결제 내역을 조회하지 못했습니다. 잠시 후 새로고침하거나 고객센터로 문의해 주세요.';
  }
  const handlePaymentRefresh = React.useCallback(async () => {
    if (typeof window !== 'undefined' && typeof window.location?.reload === 'function') {
      window.location.reload();
      return;
    }
    setDetailRefreshKey((prev) => prev + 1);
  }, []);
  const renderPaymentActionBlock = React.useCallback(() => {
    if (!canUseReservationDetailPayment) {
      if (paymentAction?.reason === 'PAYMENT_REVIEW_REQUIRED' || paymentAction?.reason === 'PAYMENT_HISTORY_UNAVAILABLE') {
        return <p className='reservation-payment-error' role='status'>{paymentAction?.description || '결제 상태를 확인하지 못했습니다. 잠시 후 새로고침하거나 고객센터로 문의해 주세요.'}</p>;
      }
      return null;
    }

    return (
      <div className='reservation-payment-cta'>
        <div className='reservation-payment-cta-copy'>
          <p className='reservation-payment-cta-title'>{paymentAction?.title || '결제 가능'}</p>
          <p className='reservation-payment-cta-note'>
            {paymentAction?.description || '현재 단계에서 결제를 진행할 수 있습니다.'}
          </p>
          {paymentAction?.retry_notice ? <p className='reservation-payment-cta-note'>{paymentAction.retry_notice}</p> : null}
        </div>
        <div className='reservation-payment-cta-meta'>
          <span className='reservation-payment-cta-amount'>{paymentActionAmountLabel}</span>
          <button
            type='button'
            className='btn reservation-payment-cta-btn'
            onClick={() => setShowPaymentModal(true)}
          >
            {paymentAction?.allow_partial === true ? '잔금 결제하기' : '결제하기'}
          </button>
        </div>
      </div>
    );
  }, [canUseReservationDetailPayment, paymentAction?.allow_partial, paymentAction?.description, paymentAction?.title, paymentAction?.reason, paymentAction?.retry_notice, paymentActionAmountLabel]);

  const categories = React.useMemo(() => {
    if (!reservationDetail) return [];

    return NAV_SECTIONS.map(section => {
      let sectionData = {};

      switch (section.id) {
        case 'passenger':
          sectionData = {
            passengers,
            itemInfo: {
              cabinType: reservationDetail.cabin_type,
              cabinNumber: reservationDetail.cabin_number,
              dinnerTime: reservationDetail.dinner_time,
              bedType: reservationDetail.bed_type,
              cabinPerson: reservationDetail.cabin_person,
              receivedTotal,
              spriceTotal,
              paymentSummary,
              paymentReceipts,
              status: statusClass,
              promotions: selectedPromotions,
              extras: selectedExtras,
              onboardCredit: onboardCreditSummary,
            },
          };
          break;
        case 'schedule':
          sectionData = {
            simple: scheduleData.simple,
            detail: scheduleData.detail,
            map: scheduleData.map,
          };
          break;
        case 'benefit':
          sectionData = {
            benefit: isMscLine
              ? MSC_BENEFITS
              : (isNorwegianLine
                ? NORWEGIAN_BENEFITS
                : (isRoyalCaribbeanLine
                  ? ROYAL_CARIBBEAN_BENEFITS
                  : (isDisneyLine ? DISNEY_BENEFITS : DEFAULT_BENEFITS)))
          };
          break;
        case 'caution':
          sectionData = {
            caution: isMscLine
              ? MSC_CAUTION
              : (isNorwegianLine
                ? NORWEGIAN_CAUTION
                : (isRoyalCaribbeanLine
                  ? ROYAL_CARIBBEAN_CAUTION
                  : (isDisneyLine ? DISNEY_CAUTION : DEFAULT_CAUTION)))
          };
          break;
        case 'term':
          sectionData = {
            term: isMscLine
              ? withMscBellissimaCancelNotice(MSC_TERMS, mscCancelNoticeContext, { requireReservationDate: true })
              : (isNorwegianLine
                ? NORWEGIAN_TERMS
                : (isRoyalCaribbeanLine
                  ? ROYAL_CARIBBEAN_TERMS
                  : (isDisneyLine ? DISNEY_TERMS : DEFAULT_TERMS)))
          };
          break;
        default:
          sectionData = {};
      }

      return {
        id: section.id,
        name: section.name,
        Component: section.Component,
        data: {
          ...sectionData,
          recordId: urlIdx,
          status: statusClass,
          lineId,
        },
      };
    });
  }, [
    reservationDetail,
    receivedTotal,
    spriceTotal,
    paymentSummary,
    paymentReceipts,
    selectedPromotions,
    selectedExtras,
    onboardCreditSummary,
    passengers,
    scheduleData,
    statusClass,
    urlIdx,
    lineId,
    isMscLine,
    isNorwegianLine,
    isRoyalCaribbeanLine,
    isDisneyLine,
    mscCancelNoticeContext,
  ]);

  const sailDate = reservationDetail?.sail_date;
  const arrivalDate = reservationDetail?.end_date;
  const departurePort = reservationDetail?.departure_port;
  const arrivalPort = reservationDetail?.arrival_port;
  const shipName = reservationDetail?.ship_name;
  const cabinType = reservationDetail?.cabin_type;
  const cabinNumber = reservationDetail?.cabin_number;
  const cabinPerson = reservationDetail?.cabin_person;
  const adminBaseUrl = 'https://admin.wowcruise.kr';
  const ticketUrlRaw = typeof reservationDetail?.ticket_url === 'string'
    ? reservationDetail.ticket_url.trim()
    : '';
  const ticketUrl = ticketUrlRaw
    ? (ticketUrlRaw.startsWith('http') ? ticketUrlRaw : `${adminBaseUrl}${ticketUrlRaw}`)
    : '';
  const hasTicketUrl = ticketUrl !== '';
  const reviewWritable = reservationDetail?.review_writable === true;
  const reviewExistingId = Number(reservationDetail?.review_existing_id ?? 0);
  const reviewAvailableAt = reservationDetail?.review_available_at || '';

  return (
    <div className='detail'>
      {reservationLoading ? (
        <p className='detail-loading'>상세 정보를 불러오는 중입니다.</p>
      ) : reservationError ? (
        <p className='detail-error'>{reservationError}</p>
      ) : reservationDetail ? (
        <div className='detail-top'>
          <div className='status-wrapper'>
            <span className={`status ${statusClass}`}>
              {statusLabel}
            </span>
            {reservationCodeFromState || reservationDetail?.reservation_code ? (
              <p className='reservation-number'><span className='res-name'>예약번호</span><span className='res-value'>{reservationCodeFromState || reservationDetail?.reservation_code}</span></p>
            ) : null}
          </div>

          <h2 className='detail-item-name'>{shipName || '-'}</h2>

          <div className='detail-item-info'>
            <p className='content'>출발일자<span className='value'>{sailDate || '-'}</span></p>
            <p className='content'>출발항구<span className='value'>{departurePort || '-'}</span></p>
            <p className='content'>도착일자<span className='value'>{arrivalDate || '-'}</span></p>
            <p className='content'>도착항구<span className='value'>{arrivalPort || '-'}</span></p>
            <p className='content'>크루즈선<span className='value'>{shipName || '-'}</span></p>
            <p className='content'>선실타입<span className='value'>{cabinType || '-'}</span></p>
            <p className='content'>선실번호<span className='value'>{cabinNumber || '-'}</span></p>
            <p className='content'>수용인원<span className='value'>{cabinPerson ? `${cabinPerson}명` : '-'}</span></p>
          </div>

          {statusClass !== 'onBoard' && (
            <div className={`contents-wrapper ${statusClass}`}>
              {(() => {
                switch (statusClass) {
                  case 'reserved':
                    return (
                      <>
                        <h3 className='title'>예약이 완료되었습니다.</h3>
                        <p className='content'>결제를 완료하시면 티켓 발행 안내를 받으실 수 있습니다.</p>
                        {renderPaymentActionBlock()}
                      </>
                    );
                  case 'paid':
                    return (
                      <>
                        <h3 className='title'>{partialPaymentNotice.title}</h3>
                        <p className='content'>{partialPaymentNotice.description}</p>
                        {renderPaymentActionBlock()}
                      </>
                    );
                  case 'issuance':
                    return (
                      <>
                        <h3 className='title'>크루즈 티켓 발급 및 필수 서류</h3>
                        <div className='content'>
                          <div className='essential-content'>
                            <ul>
                              <li>크루즈 티켓</li>
                              <li>여권(귀국일 기준 잔여 유효기간 6개월 이상 필수)</li>
                              <li>수하물 태그(인쇄하여 수하물에 부착)</li>
                            </ul>

                            <div className='extra'>
                              <p>*크루즈 티켓 발급을 위해 온라인 체크인을 완료해 주셔야 합니다.</p>
                              <p>*아래의 버튼을 통해 크루즈 티켓 다운로드가 가능합니다. 크루즈 티켓을 인쇄 후, 탑승 시 제출하시기 바랍니다.</p>
                            </div>
                          </div>

                          {hasTicketUrl && (
                            <button
                              type='button'
                              className='btn ticket-download-btn'
                              onClick={() => {
                                window.open(ticketUrl, '_blank', 'noopener');
                              }}
                            >
                              크루즈 티켓 다운로드
                            </button>
                          )}
                          {/* 예약확정서 버튼: 향후 재오픈 가능하도록 코드 보존 */}
                          {false && urlIdx && (
                            <button
                              type='button'
                              className='btn confirm-paper-btn'
                              onClick={() => {
                                const targetUrl = `https://admin.wowcruise.kr/paper/index.php?reservation_idx=${encodeURIComponent(urlIdx)}&from_mypage=1`;
                                window.open(
                                  targetUrl,
                                  'reservation-confirm',
                                  'width=900,height=700,scrollbars=yes'
                                );
                              }}
                            >
                              <svg
                                className='confirm-paper-icon'
                                width='18'
                                height='18'
                                viewBox='0 0 24 24'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                                aria-hidden='true'
                              >
                                <path
                                  d='M7 3h7l5 5v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z'
                                  stroke='currentColor'
                                  strokeWidth='1.5'
                                />
                                <path d='M14 3v5h5' stroke='currentColor' strokeWidth='1.5' />
                                <path d='M9 12h6M9 16h6' stroke='currentColor' strokeWidth='1.5' />
                              </svg>
                              예약확정서 보기
                            </button>
                          )}
                        </div>
                      </>
                    );
                  case 'external':
                    return (
                      <>
                        <h3 className='title'>연동된 예약입니다.</h3>
                        <p className='content'>외부 채널을 통해 생성된 예약을 고객 계정에서 확인할 수 있도록 연동하는 기능입니다.</p>
                      </>
                    );
                  case 'cancel':
                    return (
                      <>
                        <h3 className='title'>취소가 완료된 예약입니다.</h3>
                        <p className='content'>취소된 예약은 결제/잔여금액을 표시하지 않습니다.</p>
                      </>
                    );
                  default:
                    return null;
                }
              })()}
            </div>
          )}

          {urlIdx && statusClass !== 'cancel' && (reviewExistingId > 0 || reviewWritable) && (
            <div className='reservation-payment-cta'>
              <div className='reservation-payment-cta-copy'>
                <p className='reservation-payment-cta-title'>
                  {reviewExistingId > 0 ? '리뷰 작성 완료' : '리뷰 작성이 가능합니다.'}
                </p>
                <p className='reservation-payment-cta-note'>
                  {reviewExistingId > 0
                    ? '작성하신 크루즈 여행 후기를 확인해 보세요.'
                    : '함께한 크루즈 여행의 후기를 남겨주세요.'}
                </p>
              </div>
              <div className='reservation-payment-cta-meta'>
                <button
                  type='button'
                  className='btn reservation-payment-cta-btn'
                  onClick={() => navigate(reviewExistingId > 0
                    ? `/review/${reviewExistingId}`
                    : `/review/write?reservation_idx=${encodeURIComponent(urlIdx)}`)}
                >
                  {reviewExistingId > 0 ? '내가 작성한 리뷰 보기' : '리뷰 쓰기'}
                </button>
              </div>
            </div>
          )}
        </div>
      ) : (
        <p className='no-detail-message'>상세 정보를 불러올 수 없습니다.</p>
      )}

      {categories.length > 0 && (
        <CommonNavComponent categories={categories} />
      )}

      {urlIdx && !reservationLoading && reservationDetail && (statusClass === 'paid' || statusClass === 'issuance') && (
        <div className='reservation-contact-block'>
          <p className='reservation-contact-message'>{CANCEL_CONTACT_MESSAGE}</p>
          <button type='button' className='kakao-channel-btn' onClick={openKakaoChat}>
            카카오톡 채널상담
          </button>
        </div>
      )}

      {urlIdx && !reservationLoading && reservationDetail && statusClass !== 'cancel'
        && !(reviewExistingId > 0) && !reviewWritable
        && (reviewAvailableAt || reservationDetail?.review_reason === 'review_deleted') && (
        <div className='reservation-contact-block'>
          <p className='reservation-contact-message'>
            {reviewAvailableAt
              ? `리뷰 작성 가능일: ${reviewAvailableAt}`
              : '삭제한 리뷰의 복구·재작성은 고객센터에 문의해주세요.'}
          </p>
        </div>
      )}
      <ReservationPaymentModal
        show={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        reservationDetail={reservationDetail}
        paymentAction={paymentAction}
        onPaymentSuccess={handlePaymentRefresh}
      />
    </div>
  );
}

export default MypageDetail;
